const CUSTOM_FIELD_SIDES = ['left', 'right'];

/** Returns true if any custom field in the tab layout is marked mandatory. */
export const hasMandatoryCustomFields = (customFieldsTab) => {
  if (!customFieldsTab || !Object.keys(customFieldsTab).length) {
    return false;
  }

  return Object.keys(customFieldsTab).some((tabName) => {
    const tab = customFieldsTab[tabName];
    if (!tab) {
      return false;
    }

    return CUSTOM_FIELD_SIDES.some((side) =>
      (tab[side] || []).some((field) => field?.values?.mandatory === true)
    );
  });
};

export const transformProcess = (processes, processId) => {
  const process = processes.find(process => process.id === processId);
  const { id, name, selectedProcessType, processStages } = process;

  const stages = processStages.reduce((acu, cur, ix) => {
    const { id: stageId, name: stageName, notifications: nots, approvals: apps, customFieldsTab, goBackEnabled, goBackTo, isAssetEdition, isCustomLockedStage, isSelfApprove, isSelfApproveContinue, isControlDueDate, isSingleApprover, locationManagerRecursive } = cur;
    const notifications = nots.map((not) => ({ ...not, sent: false, sentDate: '' }));
    const approvals = apps.map((app) => ({ ...app, fulfilled: false, fulfillDate: '' }));
    const stage = { stageId, stageName, notifications, approvals, customFieldsTab,  stageFulfilled: false, stageInitialized: false, goBackEnabled: goBackEnabled || false, goBackTo: goBackTo || '', isAssetEdition, isCustomLockedStage, isSelfApprove, isSelfApproveContinue, isControlDueDate, isSingleApprover, locationManagerRecursive: locationManagerRecursive === true };

    return [...acu, stage];
  }, []);

  return {
    currentStage: 0,
    id,
    name,
    selectedProcessType,
    stages,
    totalStages: processStages.length
  };
};
